/**
 * Shared event date formatter.
 * Uses the native Intl API with locale-native time format
 * (12h for en, 24h for de/fr/es).
 */
export const createFormatEventDate = (language) => (startDate, endDate) => {
  if (!startDate) return '';
  const start = new Date(startDate);
  const end = endDate ? new Date(endDate) : null;

  const datePart = start.toLocaleDateString(language, {
    weekday: 'short', month: 'short', day: 'numeric'
  });
  const timePart = start.toLocaleTimeString(language, {
    hour: 'numeric', minute: '2-digit'
  });

  if (end && start.toDateString() !== end.toDateString()) {
    const endDatePart = end.toLocaleDateString(language, {
      weekday: 'short', month: 'short', day: 'numeric'
    });
    const endTimePart = end.toLocaleTimeString(language, {
      hour: 'numeric', minute: '2-digit'
    });
    return `${datePart} • ${timePart} \u2013 ${endDatePart} • ${endTimePart}`;
  }
  return `${datePart} • ${timePart}`;
};

export const formatEventTime = (date, language) => {
  if (!date) return '';
  return new Date(date).toLocaleTimeString(language, {
    hour: 'numeric', minute: '2-digit'
  });
};
